import { useTheme } from "@mui/material";
import React from "react";
import Checkbox from "@mui/material/Checkbox";
import { LightTooltip } from "../../../../kit/LightToolTip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import "./style.scss";
function MultiSelectCheckBox({
  label,
  type,
  checkList,
  isRequired = false,
  isDisabled = false,
  onChange,
  info = "",
  categoryId,
  componentId,
}) {
  const theme = useTheme();

  return (
    <div>
      <div
        style={{
          fontSize: theme.size[12],
          fontWeight: theme.fontWeight[500],
          color: theme.palette.rapidInfra.text,
        }}
      >
        {label}
        {isRequired && (
          <span
            style={{ color: theme.palette.rapidInfra.required, marginLeft: 5 }}
          >
            *
          </span>
        )}
        {info && (
          <LightTooltip
            title={info}
            placement="top"
            arrow
            sx={{
              "& .MuiTooltip-tooltip": {
                padding: "8px 12px", // Adjust padding if needed
              },
            }}
          >
            <InfoOutlinedIcon
              style={{
                fontSize: theme.size[14],
                color: theme.palette.rapidInfra.infoIcon,
                marginLeft: 5,
                cursor: "pointer",
              }}
            />
          </LightTooltip>
        )}
      </div>
      <div style={{ display: "flex" }}>
        {checkList.map((item, index) => {
          const isQA =
            typeof item?.property_value === "string" &&
            item.property_value.toLowerCase() === "qa";
          const disabledForThisItem = isDisabled || isQA;

          return (
            <div
              key={index}
              style={{
                display: "flex",
                alignItems: "flex-start",
                width: 100 / checkList.length + "%",
                opacity: isQA ? 0.6 : 1,
                pointerEvents: isQA ? "none" : "auto",
              }}
      
            >
              <Checkbox
                checked={item.is_checked}
                onChange={() =>
                  onChange(categoryId, componentId, item.property_id)
                }
                inputProps={{ "aria-label": "controlled" }}
                disabled={disabledForThisItem}
                sx={{
                  color: theme.palette.secondary.main,
                  padding: "2px",
                  "&.Mui-checked": {
                    color: disabledForThisItem
                      ? theme.palette.rapidInfra.disabledGrey
                      : theme.palette.secondary.main,
                  },
                  "& .MuiSvgIcon-root": {
                    fontSize: 20,
                  },
                }}
              />
              <div style={{ marginLeft: theme.size[8] }}>
                <div
                  style={{
                    fontSize: theme.size[14],
                    color: isQA ? "#BDBDBD" : theme.palette.rapidInfra.text,
                  }}
                >
                  {item.property_value}
                </div>
                <LightTooltip
                  title={item.description}
                  placement="top"
                  arrow
                  sx={{
                    "& .MuiTooltip-tooltip": {
                      padding: "8px 12px",
                    },
                  }}
                >
                  <div
                    className="two-line-ellipsis"
                    style={{
                      fontSize: theme.size[12],
                      color: isQA ? "#BDBDBD" : theme.palette.rapidInfra.text,
                      fontWeight: theme.fontWeight[500],
                    }}
                  >
                    {item.description}
                  </div>
                </LightTooltip>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default MultiSelectCheckBox;
